import { PermissaoEnum } from "core/resources/enums/permissao";

export enum TabsDetalheAssembleiaRoutes {
  Editar = "editar",
  Perguntas = "perguntas",
  Participantes = "participantes",
  Procuracoes = "procurações",
  Resultado = "resultado",
  Relatorio = "relatório",
  Video = "video",
}

export const TabsDetalheAssembleia: {
  label: string;
  route: TabsDetalheAssembleiaRoutes;
  permissions: string[];
}[] = [
  {
    label: "Editar Votação",
    route: TabsDetalheAssembleiaRoutes.Editar,
    permissions: [],
  },
  // {
  //   label: "Perguntas",
  //   route: TabsDetalheAssembleiaRoutes.Perguntas,
  //   permissions: [],
  // },
  {
    label: "Participantes",
    route: TabsDetalheAssembleiaRoutes.Participantes,
    permissions: [],
  },
  {
    label: "Procurações",
    route: TabsDetalheAssembleiaRoutes.Procuracoes,
    permissions: [],
  },
  {
    label: "Resultado",
    route: TabsDetalheAssembleiaRoutes.Resultado,
    permissions: [PermissaoEnum.Backoffice.Administrativo.Votacao.Resultado],
  },
  {
    label: "Vídeo Conferência",
    route: TabsDetalheAssembleiaRoutes.Video,
    permissions: [],
  },
  {
    label: "Relatório",
    route: TabsDetalheAssembleiaRoutes.Relatorio,
    permissions: [],
  },
];
